module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/bachelorparty-0397e50fcc229f278affc39fbca20147.webp";